export const SET_SELECTED_STATE = "set/selected/state";
export const RESET_SELECTED_STATE = "reset/selected/state";

export const SET_SELECTED_HOSPITAL = "set/selected/hospital";

export const SET_SPECIFIC_STATE_DATA = "set/specific/state/data";
export const RESET_SPECIFIC_STATE_DATA = "RESET_SPECIFIC_STATE_DATA";